import { posthog } from "./posthogUtil";

/**
 * options example:
 * ```jsx
 * trackingDebug(true) // debug:true only
 * // or
 * trackingDebug({ debug: true, posthogDebug: true });
 * ```
 */
export function trackingDebug(options) {
  if (typeof options === 'boolean') {
    localStorage.setItem('isTrackingDebug', String(options));
  } else {
    var _options$debug;
    localStorage.setItem('isTrackingDebug', String((_options$debug = options === null || options === void 0 ? void 0 : options.debug) !== null && _options$debug !== void 0 ? _options$debug : false));
    if (options !== null && options !== void 0 && options.posthogDebug) {
      posthog.debug(options.posthogDebug);
    }
  }
}
export function log() {
  if (localStorage.getItem('isTrackingDebug')) {
    var _console;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    (_console = console).log.apply(_console, ['[EventTrackingDbg]: '].concat(args));
  }
}